export const noop = () => {
  /* noop */
};
